import * as yup from "yup";
import type { Asserts } from "yup";

// Response from /pickup-timeframes validation

const timeFrameSchema = yup.object({
  timeFrameFrom: yup.array().of(yup.string().required()).required(),
  timeFrameTo: yup.array().of(yup.string().required()).required(),
  minimalInterval: yup.number().required(),
  cutoff: yup.number().required(),
});

const pickupTimeFrameSchema = yup.object({
  date: yup.string().required(),
  timeFramesDTO: timeFrameSchema.default(undefined),
});

const pickupTimeFramesSchema = yup.object({
  timeFrames: yup.array().of(pickupTimeFrameSchema).required(),
});

export type TPickupTimeFramesResponse = Asserts<typeof pickupTimeFramesSchema>;

const validatePickupTimeFramesResponse = (response: any): TPickupTimeFramesResponse =>
  pickupTimeFramesSchema.validateSync(response);

export default validatePickupTimeFramesResponse;
